import { Button } from "@mui/material";
import { useEffect, useState } from 'react';
import { getEmailTemplate, saveEmail } from '../../services/emailService';
import EditorTiptap from './EditorTipTap';

const EmailTemplate = () => {
    const [email, setEmail] = useState('');
    const [htmlEmail, setHtmlEmail] = useState('');

    useEffect(() => {
        const fetch = async () => {
            const template = await getEmailTemplate({fileName: 'email-template-pt.html'});
            setEmail(template || '');
            setHtmlEmail(template || '');
        };
        fetch();
    }, []);

    return (
        <div style={{margin: '30px'}}>
            <EditorTiptap
                value={email}
                onChange={(novoHtml) => setHtmlEmail(novoHtml)}
            />
            <Button
                sx={{ textTransform: "capitalize", color: "#fff", mt: 1, float: 'right' }}
                color="tertiary"
                variant="contained"
                onClick={async () =>
                    await saveEmail({htmlEmail})
                }
            >
            Salvar mudanças no e-mail
            </Button>
        </div>
    );
};

export default EmailTemplate;
